import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'UPDATE_INVOICE_BY_ID';

export async function updateInvoiceById(
    userToken: string,
    invoiceId: number,
    update: Record<string, unknown>
) {

    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/invoices/${invoiceId}/`,
            data: update,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: getInvoiceUpdateErrorMessage(error),
            error: error
        });
    }
}

function getInvoiceUpdateErrorMessage(error: unknown) {
    const data = (error as {response?: {data?: unknown}})?.response?.data;

    if (typeof data === 'string') {
        return data;
    }

    if (Array.isArray(data) && typeof data[0] === 'string') {
        return data[0];
    }

    if (data && typeof data === 'object') {
        const responseData = data as {detail?: unknown; non_field_errors?: unknown};

        if (typeof responseData.detail === 'string') {
            return responseData.detail;
        }

        if (typeof responseData.non_field_errors === 'string') {
            return responseData.non_field_errors;
        }

        if (
            Array.isArray(responseData.non_field_errors)
            && typeof responseData.non_field_errors[0] === 'string'
        ) {
            return responseData.non_field_errors[0];
        }
    }

    return 'Erreur de modification de la facture';
}

